/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSessionApiV1SessionPost } from '../fn/session/create-session-api-v-1-session-post';
import { CreateSessionApiV1SessionPost$Params } from '../fn/session/create-session-api-v-1-session-post';
import { getSessionsApiV1SessionGet } from '../fn/session/get-sessions-api-v-1-session-get';
import { GetSessionsApiV1SessionGet$Params } from '../fn/session/get-sessions-api-v-1-session-get';
import { SessionRead } from '../models/session-read';

@Injectable({ providedIn: 'root' })
export class SessionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSessionsApiV1SessionGet()` */
  static readonly GetSessionsApiV1SessionGetPath = '/api/v1/session';

  /**
   * Get Sessions.
   *
   * Get all sessions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSessionsApiV1SessionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSessionsApiV1SessionGet$Response(params?: GetSessionsApiV1SessionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionRead>>> {
    return getSessionsApiV1SessionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Sessions.
   *
   * Get all sessions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSessionsApiV1SessionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSessionsApiV1SessionGet(params?: GetSessionsApiV1SessionGet$Params, context?: HttpContext): Observable<Array<SessionRead>> {
    return this.getSessionsApiV1SessionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SessionRead>>): Array<SessionRead> => r.body)
    );
  }

  /** Path part for operation `createSessionApiV1SessionPost()` */
  static readonly CreateSessionApiV1SessionPostPath = '/api/v1/session';

  /**
   * Create Session.
   *
   * Create a new session
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSessionApiV1SessionPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  createSessionApiV1SessionPost$Response(params?: CreateSessionApiV1SessionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionRead>> {
    return createSessionApiV1SessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Session.
   *
   * Create a new session
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSessionApiV1SessionPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createSessionApiV1SessionPost(params?: CreateSessionApiV1SessionPost$Params, context?: HttpContext): Observable<SessionRead> {
    return this.createSessionApiV1SessionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionRead>): SessionRead => r.body)
    );
  }

}
